// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"d6911f00","28":"4f99e74c","268":"088e558a","329":"caed344d","366":"01e9a5b2","376":"04685b20","418":"70435299","462":"4f7a0ca8","772":"d6e2ae9d","886":"ac018daa"}[chunkId] + ".chunk.js";
};